<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          ログ
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">ログ</a>
        </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <b-row>
              <b-col>
                <strong>ログ詳細 ({{ model.id }})</strong>
                <span class="float-right">日付 : {{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>クライアント情報</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>攻撃元: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        <b-link v-if="id" href="javascript:void(0)" @click="copy(model.remote_addr)" v-b-tooltip.hover title="クリックしてコピー">
                          {{model.remote_addr ? model.remote_addr : '-'}}
                        </b-link>
                        <span v-else>
                          {{model.remote_addr ? model.remote_addr : '-'}}
                        </span>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>
                        XFF:
                        <span class="text-info" v-b-tooltip.hover.right="'XFF: Shows X-Forwarded-For data if a proxy is set'">
                          <i style='cursor: pointer;' @click="info_xff = true" class="fa fa-question-circle"></i>
                        </span>
                      </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        {{ model.xff ? model.xff : '-' }}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>国名: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_remote_addr" v-b-tooltip.hover>
                        <span v-if="model.country" class="flag-icon" :class="set_flag(model.country)"></span>
                        {{model.country ? model.country : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_protocol" v-b-tooltip.hover>プロトコル: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_protocol" v-b-tooltip.hover>
                        {{model.protocol ? model.protocol : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_port" v-b-tooltip.hover>ソースポート: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        {{model.client_port ? model.client_port : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_method" v-b-tooltip.hover>方式: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_method" v-b-tooltip.hover>
                        {{model.method ? model.method : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_request" v-b-tooltip.hover>リクエスト(Byte): </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_request" v-b-tooltip.hover>
                        {{model.request_size ? model.request_size : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_response" v-b-tooltip.hover>応答(Byte): </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_response" v-b-tooltip.hover>
                        {{model.response_size ? model.response_size : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>サーバ情報</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>ホスト(ドメイン:)</label>
                    </b-col>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover >{{model.host}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>送信先ポート:</label>
                    </b-col>
                    <b-col>
                      -
                      <!-- <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>被害:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model">{{model.target}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>パブリック:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_public ? model.agent.ip_addr_public : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>プライベート:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_private ? model.agent.ip_addr_private : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>WAS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.iwaf_type ? model.agent.iwaf_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>OS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.os_type ? model.agent.os_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>ホスト:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.host ? model.agent.host : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row v-if="model.agent && model.agent.nickname != model.agent.host">
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>名前:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.nickname ? model.agent.nickname : '-'}}</label>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label for="ph_uri" v-b-tooltip.hover>
                        URI <small>:</small>
                        <b-button v-if="model.uri.length > 100" size="sm" @click="view_split_uri = !view_split_uri" variant="info">
                          {{view_split_uri ? 'split' : 'origin'}} view
                        </b-button>
                      </label>
                    </b-col>
                    <b-col>
                      <pre v-if="view_split_uri" for="ph_uri" v-b-tooltip.hover>{{model.uri}}</pre>
                      <pre v-else>{{split_uri(model.uri || '')}}</pre>
                    </b-col>
                  </b-row> -->

                </div>
              </b-col>
              <b-col md="6" style="border-left: 1px solid #dcdcdc;">
                <h4>
                  脅威の情報
                  <Bell v-if="model.message && model.message.messages && model.message.messages.length > 1" style="display: inline-block" :size="20" :count="model.message.messages.length" />
                </h4>

                <hr>
                <div>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" for="ph_response">応答(アクション):</label>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.is_block && this.model.block_cnt > 0" variant="danger">ブロックモード</b-badge>
                      <b-badge v-else variant="warning">検出モード</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="cursor:pointer" md="3">
                      <label for="ph_response" class="font-weight-bold">リスク:</label>
                      <span class="text-info" v-b-tooltip.hover title="複数のログが存在する場合、最も危険なログが表示されます。未定義のログには「低い」リスクがマークされます。">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity, 'variant')">
                        {{codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'EN')}}
                      </b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>ポリシーID:</label>
                      <span class="text-info" v-b-tooltip.hover title="指定したポリシー番号を表示します。 ユーザーポリシーの場合は、ユーザーの設定に応じて柔軟に設定されます（8,000,000～8,999,999）">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-link v-if="id" href="javascript:void(0)" @click="() => quick_search(model.m_id, model)" v-b-tooltip.hover title="ユーザー ポリシーではない場合は、[エージェント] ページでポリシーを直接検索できます。ここをクリックしてください。">
                        {{ model.m_id ? model.m_id : '-' }}
                      </b-link>
                      <span v-else>
                        {{ model.m_id ? model.m_id : '-' }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover class="font-weight-bold">ポリシー名:</label>
                    </b-col>
                    <b-col>
                      {{ policy_domain() ? policy_domain() : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover>
                        <label class="font-weight-bold">メッセージ:</label>
                      </label>
                    </b-col>
                    <b-col>
                      <strong>{{ model.title_i18n ? (temp_i18n[model.title_i18n['EN'].desc] ? temp_i18n[model.title_i18n['EN'].desc] : model.title_i18n['EN'].desc) : (model.title ? model.title : i18nmsg) }}</strong>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label v-b-tooltip.hover>CVE</label>
                    </b-col>
                    <b-col>
                      {{ '-' }}
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>タグ:</label>
                    </b-col>
                    <b-col>
                      <span v-for="(x) in tags()">
                        {{ x || '-' }} <br>
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="parser_request">
              <b-col md="12">
                <b-form-group>
                  <b>
                    <label for="ph_request" v-b-tooltip.hover>
                      リクエスト<small>:</small>
                    </label>
                    <b-button size="sm" @click="view_split_request = !view_split_request" variant="info">
                      {{view_split_uri ? 'split' : 'origin'}} view
                    </b-button>
                  </b>
                  <pre class="bg-secondary" v-if="view_split_request" for="ph_uri" v-b-tooltip.hover>{{model.request}}</pre>
                  <pre v-else class="bg-secondary">{{split_uri(model.request || '')}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr v-if="has_get_parameter()">
            <b-row v-if="has_get_parameter()">
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>リクエスト</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.request}}</pre>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b><label v-b-tooltip.hover>リクエストパラメーター</label><br></b>
                  <table>
                    <thead>
                      <th class="border border-dark p-2">名前</th>
                      <th class="border border-dark p-2">バリュー</th>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in parameter()" v-bind:key="index">
                        <td class="p-2">
                          {{x.key}}
                        </td>
                        <td class="p-2">
                          {{x.value}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>リクエストヘッダー</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : 'データはありません'}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <center>
              マッチング情報
              <!-- <span class="float-right">
                <span class="text-danger">*</span>
                現在のポリシーで利用可能なオプション ({{ model.target }}})
              </span> -->
            </center>
            <hr>
            <table v-if="is_error" class="table table-sm table-dark">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">メッセージ</th>
                  <th scope="col">ルールID</th>
                  <!-- <th scope="col">成熟度</th>
                  <th scope="col">精度</th> -->
                  <th scope="col">レスポンス</th>
                  <th scope="col">リスク</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <th scope="col" colspan="5">
                    元データに誤りがあったため、サポートを確認する必要があります。
                  </th>
                </tr>
              </tbody>
            </table>
            <table v-else class="table table-sm table-dark text-center">
              <thead>
                <tr>
                  <th scope="col" rowSpan="2">#</th>
                  <th scope="col" rowSpan="2">メッセージ</th>
                  <th scope="col" rowSpan="2" @click="info_threat = true" style="cursor:pointer">
                    Response & Threat
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <th v-if="!only_view" scope="col">
                    Manage
                    <span class="text-info" v-b-tooltip.hover :title="this.m_Title">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <th v-if="!only_view" scope="col">現在の状態</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                  <th scope="row">
                    <b-link v-if="id" href="javascript:void(0)" @click="() => quick_search(row.details.ruleId)" v-b-tooltip.hover title="指定したポリシー番号を表示します。 ユーザーポリシーの場合は、ユーザーの設定に応じて柔軟に設定されます（8,000,000～8,999,999）">
                      {{ row.details.ruleId ? row.details.ruleId : '-' }}
                    </b-link>
                    <span v-else>
                      {{ row.details.ruleId ? row.details.ruleId : '-' }}
                    </span>
                  </th>
                  <th scope="row">
                    <span class="text-info" v-if="row.details.i18n && row.details.i18n['EN'] && row.details.i18n['EN'].desc" @click="base_policy(row.details)">
                      <i class="fas fa-question-circle"></i>
                    </span>
                    <strong>{{detectInfo ? detectLog[index] : row.message}}</strong>
                    <!-- <strong>{{ row.details.i18n && row.details.i18n['EN'] ? (temp_i18n[row.details.i18n['EN'].desc] ? temp_i18n[row.details.i18n['EN'].desc] : row.details.i18n['EN'].desc) : (ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['EN'] : row.message) }}</strong> -->
                  </th>
                  <th scope="row">
                    <!-- <p>ポリシーID : {{row.details.ruleId}} </p> -->
                    <!-- <span>{{row.details.ruleId}} </span>
                    <br> -->
                    <span>
                      <!-- {{row.details.tags}} -->
                      <!-- Response: -->
                      <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                      <b-badge v-else-if="row.details.is_block" variant="danger">ブロック</b-badge>
                      <b-badge v-else variant="warning">検出</b-badge>
                    </span>
                    <br>
                    <span>
                      <!-- Risk: -->
                      <span scope="row">
                        <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.details.severity, 'variant')">
                          {{codes.WAF_SEVERITY_TO_DESC_EASY(row.details.severity, 'EN')}}
                        </b-badge>
                      </span>
                    </span>
                  </th>
                  <th v-if="!only_view && !loading" scope="row">
                    <b-button :disabled="version < 202207 ? (onOff[index] || check_custom(row.details)) : (row.now_status == codes.WAF_MODE_OFF.VALUE || check_custom(row.details))"  @click=" exception_info = {  applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception,  }; exception_info_modal_add = true; exception_info_modal_remove = false;" size="sm" style="width: fit-content; font-weight: bold;" variant="danger">
                      <span v-if="row.is_domain && !row.is_exception_domain" style="font-size:1.2rem; padding:0px; margin:0px;" class="text-danger">*</span>
                      ポリシーオフ
                    </b-button>
                    <b-button :disabled="version < 202207 ? (!onOff[index] || check_custom(row.details)) : (row.now_status != codes.WAF_MODE_OFF.VALUE || check_custom(row.details))" @click=" exception_info = {  applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_remove = true; exception_info_modal_add = false;" size="sm" style="width: fit-content; font-weight: bold;" variant="warning">
                      <span v-if="row.is_domain && row.is_exception_domain" style="font-size:1.2rem;" class="text-danger">*</span>
                      ポリシーオン
                    </b-button>
                  </th>
                  <th v-if="!only_view && row.now_status != null"  class="text-weight-bold">
                    {{codes.WAF_MODE_I18N(row.now_status, 'EN')}}
                  </th>
                  <th v-else  class="text-weight-bold">
                    -
                  </th>
                </tr>
              </tbody>
            </table>
            <hr>

            <b-button v-if="!id" size="sm" class="float-right" @click="list">一覧</b-button>
          </b-card>
        </b-col>
      </b-row>
      <!-- result modal -->
      <b-modal size="m" title="検出の説明"  class="modal-info" v-model="info_base_policy.is_show" hide-footer @ok="info_base_policy.is_show = false">
        の詳細な基礎情報を提供します。
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason.match || '-'}}
        </pre>
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason.data || '-'}}
        </pre>
      </b-modal>
      <!-- <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-info" v-model="info_xff" hide-footer @ok="info_xff = false">
        XFF: プロキシがX-Forwarded-Forに設定されている場合に表示されます
      </b-modal> -->
      <!-- 정책 미사용 모달  -->
      <b-modal size="l" title="ポリシーを無効にするには"  class="modal-success" v-model="exception_info_modal_add" @ok="add_white">
        <p>{{exception_policy_id}} 未使用のままスタティックジャックを適用しますか？</p>
        <p>{{policy_domain()}} ポリシーは未使用に変更され、検出ログに表示されなくなります。</p>
        <!-- <hr> -->
        <!-- <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="check_disabled(x)">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group> -->
        <!-- <hr>
        <p>* 적용할 정책 대상을 선택해주세요</p> -->
      </b-modal>
      <b-modal size="m" title="ポリシーの使用を有効にするには"  class="modal-success" v-model="exception_info_modal_remove" @ok="remove_white">
        <p>現在未使用のポリシーを検知に設定します。</p>
        <!-- <p v-if="exception_info.detail.i18n">{{exception_policy_id}} : {{ exception_info.detail.i18n['EN'].desc }} ポリシーをDetectionsに変更します。</p> -->
        <!-- 변경 코드-->
        <p v-if="exception_info.detail.i18n">
          {{exception_policy_id}} : {{ exception_info.detail.i18n ? exception_info.detail.i18n['EN'].desc : exception_info.msg }} ポリシーをDetectionsに変更します。
        </p>

        <p>検出に変更した際の検出ログを確認することができます。</p>
        <hr>
        <!-- <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="check_disabled(x)">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group> -->
      </b-modal>
      <b-modal size="m" title="脅威"  class="modal-info" v-model="info_threat" hide-footer @ok="info_threat = false">
        レスポンスタイプ、リスクを表示します。
        <br>
        レスポンスタイプ： 遮断（HTTP 403）、検出（HTTP 200）
        <br>
        リスク : 定義されたリスク（リスク、通知、情報、カスタマイズなど）を表示します。
      </b-modal>
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
